/**
 * Is this table free? Ask the order, not the table row.
 *
 * `tables.status` is a denormalised cache the server maintains alongside the real
 * relation (`tables.current_order_id` → `orders.status`). It drifts: a sweep found
 * eight tables sitting at status='available' while holding an order in open,
 * kot_sent or billing, so CaptainPAD, the floor plan and the billing table picker
 * all painted them VACANT and a captain tapping one dropped straight into somebody
 * else's running KOT. `scripts/reconcile_table_status.py` repairs the column; this
 * module makes the SCREENS independent of it, because the drift will happen again.
 *
 * The live order list (`GET /api/orders/active`) is the authority. `tables.status`
 * survives only as the fallback for what no order can express — a table held
 * `occupied` by a lock with no order on it yet.
 */

/** The order statuses that hold a table. Matches the FSM in docs/HANDOVER.md. */
export const LIVE_ORDER_STATUSES = ["open", "kot_sent", "billing"];

export const isLiveOrder = order =>
  !!order && (LIVE_ORDER_STATUSES.includes(order.status) || order.status === "CONFLICTED");

/**
 * The tile class: `vacant` | `occupied` | `billing`.
 *
 * The order FSM's statuses are not the tile palette — the stylesheet only colours
 * those three. Passing a raw `open`/`kot_sent` through left every punching or
 * in-kitchen table on the green the legend calls "Vacant".
 */
export const tableTone = (order, table) => {
  if (isLiveOrder(order)) return order.status === "billing" ? "billing" : order.status === "CONFLICTED" ? "conflicted" : "occupied";
  return table?.status === "billing" ? "billing" : table?.status === "occupied" ? "occupied" : "vacant";
};

/** What the tile says under the table name. */
export const toneLabel = tone =>
  tone === "billing" ? "bill printed" : tone === "conflicted" ? "conflict" : tone === "occupied" ? "occupied" : "vacant";
